// extracted by mini-css-extract-plugin
export default {"categorySelect":"booking_category_select-module___categorySelect___e8b2e1b1"};